var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMyCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0617 1.77885C13.5394 1.86524 10.5139 2.17968 8.64611 3.32302C8.51722 3.40191 8.44417 3.54218 8.44417 3.68885V13.7963C8.44417 14.1172 8.795 14.32 9.09083 14.1711C11.0125 13.2038 13.7917 12.94 15.1658 12.8677C15.635 12.843 15.9997 12.4669 15.9997 12.0161V2.63163C16 2.13968 15.5733 1.74996 15.0617 1.77885ZM7.35361 3.32302C5.48611 2.17968 2.46056 1.86552 0.938333 1.77885C0.426667 1.74996 0 2.13968 0 2.63163V12.0163C0 12.4675 0.364722 12.8436 0.833889 12.868C2.20861 12.9402 4.98917 13.2044 6.91083 14.1722C7.20583 14.3208 7.55556 14.1183 7.55556 13.7983V3.68385C7.55556 3.53691 7.48278 3.40218 7.35361 3.32302Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMyCourse);
export default __webpack_public_path__ + "static/media/IcMyCourse.2775bfa9bb527d16015c3073b7dadd8f.svg";
export { ForwardRef as ReactComponent };